import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap,
  MemoizedSelector
} from '@ngrx/store';

import * as fromCompany from './companies.reducer';
import { Store, select } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import { Company } from '../../companies.model';
// export const reducers: ActionReducerMap<any> = {
//   message: fromCompany.companyReducer
// };

// export const selectCompanyState = createFeatureSelector<fromCompany.State>('companyReducer');
export const selectCompanyState = createFeatureSelector<fromCompany.State>('companyReducer');
export const selectAddCompanyCompleted = createSelector(selectCompanyState,
  fromCompany.getCompanyStatus
);

export const selectAllOfTheCompanies = createSelector(selectCompanyState,
  fromCompany.getAllOfTheCompanies,

);

export const { selectAll: selectAllCompanies } = fromCompany.companyAdapter.getSelectors(
  selectCompanyState
);

export const {
  selectIds: companyIds,
  selectEntities: companyEntities,
  selectAll: allCompanies,
  selectTotal: totalCompanies
} = fromCompany.companyAdapter.getSelectors(selectCompanyState);


export const selectCompaniesByName = createSelector(
  allCompanies,
  (companies: Company[], { name }: { name: string }) => companies.filter(company => company.companyName.indexOf(name) !== -1 )
);

export const selectCompaniesById = createSelector(
  allCompanies,
  (companies: Company[], { id }: { id: string }) => companies.filter(company => company.id === id)
);

export const selectCompaniesPastCutOff = createSelector(
  allCompanies,
  (companies: Company[], { cutOffDate }: { cutOffDate: Date }) => companies.filter(company => new Date(company.dsEndDate).getTime() <= cutOffDate.getTime())
);



